import { effect, signal, type Signal, type EffectCleanupRegisterFn } from '@angular/core';

export function DebounceSignal<T>(source: Signal<T>, delayMs: number): Signal<T> {
    const debounced = signal<T>(source());
    let handle: ReturnType<typeof setTimeout> | null = null;

    effect(
        (onCleanup: EffectCleanupRegisterFn) => {
            const value = source();

            if (handle) {
                clearTimeout(handle);
            }

            if (delayMs <= 0) {
                debounced.set(value);
            } else {
                handle = setTimeout(() => {
                    debounced.set(value);
                }, delayMs);
            }

            onCleanup(() => {
                if (handle) {
                    clearTimeout(handle);
                    handle = null;
                }
            });
        },
        { allowSignalWrites: true }
    );

    return debounced.asReadonly();
}
